import notesAPI from '@/api/notes';
import circleAPI from '@/api/circles';

export default {
  sort: {
    options: ['created_at', 'updated_at', 'type'],
    default: '-created_at',
  },
  filters: [
    {
      name: 'Contents',
      field: 'filter[contents]',
      type: 'string',
      component: 'FiltersV2ComponentInput',
      multiple: false,
      open: false,
    },
    {
      name: 'Note Type',
      field: 'filter[notable_type]',
      type: 'string',
      component: 'FiltersV2ComponentSelect',
      multiple: true,
      open: false,
      options: [
        { label: 'Client', value: 'client' },
        { label: 'Case', value: 'case' },
        { label: 'Plan', value: 'plan' },
        { label: 'Risk', value: 'risk' },
        { label: 'Background Check', value: 'check' },
        { label: 'Task', value: 'task' },
      ],
      isVisible(self) {
        return self?.$parent?._props.forClient;
      },
    },
    {
      name: 'Date from',
      field: 'filter[date_from]',
      type: 'date',
      component: 'FiltersV2ComponentDate',
      multiple: false,
      open: false,
    },
    {
      name: 'Date to',
      field: 'filter[date_to]',
      type: 'date',
      component: 'FiltersV2ComponentDate',
      multiple: false,
      open: false,
    },
    {
      name: 'Type',
      field: 'filter[type]',
      type: 'string',
      component: 'FiltersV2ComponentSelect',
      multiple: true,
      open: false,
      options: [
        { label: 'General Notes', value: 'note' },
        { label: 'Call', value: 'call' },
        { label: 'Email', value: 'email' },
        { label: 'Meeting', value: 'meeting' },
      ],
    },
  ],

  methods: {
    applyFilters(params, data, infoObject) {
      if (infoObject.path_filters) {
        params['filter[path_exact]'] = infoObject.path_filters.flat().join(',');
      }
      if (infoObject.notable_type === 'circle') {
        return circleAPI.getNotes(infoObject.notable_uuid, {
          params: { ...params, ...{ include: 'notable' } },
        });
      } else {
        return notesAPI.getNotes(infoObject.notable_type, infoObject.notable_uuid, {
          params: { ...params, ...{ include: 'notable' } },
        });
      }
    },
  },
};
